import lazyLoading from './lazyLoading'
import CommonLayout from '../components/Layouts/Common'
import DoctorGuard from './guards/doctor-guard'

export default [
  {
    path: '/doctor',
    component: CommonLayout,
    beforeEnter: DoctorGuard,
    children: [
      {
        name: 'doctor.dashboard',
        path: 'dashboard',
        component: lazyLoading('Dashboard/Index'),
        meta: {
          module: 'dashboard',
        },
      },
      {
        name: 'doctor.appointments',
        path: 'appointments',
        component: lazyLoading('Nurse/Appointments/Index'),
        meta: {
          module: 'appointments',
        },
      },
      {
        name: 'doctor.appointments.create',
        path: 'appointments/create',
        component: lazyLoading('Nurse/Appointments/Create'),
        meta: {
          module: 'createAppointments',
        },
      },
      {
        name: 'doctor.appointments.show',
        path: 'appointments/:id',
        component: lazyLoading('Appointments/Show'),
        meta: {
          module: 'appointments',
        },
      },
      {
        name: 'doctor.new_issue',
        path: 'issue_appointments/:id?',
        component: lazyLoading('Issues/Schedule/Form'),
        meta: {
          module: 'appointments',
        },
      },
      {
        name: 'doctor.exams',
        path: 'exams',
        component: lazyLoading('Nurse/Exams/Index'),
        meta: {
          module: 'exams',
        },
      },
      {
        name: 'doctor.exams.create',
        path: 'exams/create',
        component: lazyLoading('Exams/Create'),
        meta: {
          module: 'exams',
        },
      },
      {
        name: 'doctor.exams.show',
        path: 'exams/:id',
        component: lazyLoading('Exams/Show'),
        meta: {
          module: 'exams',
        },
      },
      {
        name: 'doctor.conversations',
        path: 'conversations',
        component: lazyLoading('Conversations/Index'),
        meta: {
          module: 'chat',
        },
      },
      // medico procedures
      {
        name: 'doctor.medico.procedures',
        path: 'medical/procedures',
        component: lazyLoading('Medico/Procedures/Index'),
        meta: {
          module: 'medico',
        },
      },
      {
        name: 'doctor.medico.procedures.create',
        path: 'medical/procedures/create',
        component: lazyLoading('Medico/Procedures/Create'),
        meta: {
          module: 'medico',
        },
      },
      {
        name: 'doctor.medico.procedures.edit',
        path: 'medical/procedures/:id/edit',
        component: lazyLoading('Medico/Procedures/Edit'),
        meta: {
          module: 'medico',
        },
      },
      // ICD
      {
        name: 'doctor.medico.icd',
        path: 'medical/icd',
        component: lazyLoading('Medico/ICD/Index'),
        meta: {
          module: 'medico',
        },
      },
      {
        name: 'doctor.medico.icd.create',
        path: 'medical/procedures/create',
        component: lazyLoading('Medico/ICD/Create'),
        meta: {
          module: 'medico',
        },
      },
      {
        name: 'doctor.medico.icd.edit',
        path: 'medical/icd/:id/edit',
        component: lazyLoading('Medico/ICD/Edit'),
        meta: {
          module: 'medico',
        },
      },
      // Medical record
      {
        name: 'doctor.medico.record.edit',
        path: 'medical/record/:appointment_id',
        component: lazyLoading('Medico/MedicalRecord/Form'),
        meta: {
          module: 'medico',
        },
      },
      {
        name: 'doctor.settings.categories',
        path: 'medical/form_categories',
        component: lazyLoading('Medico/FormCategories/Index'),
        meta: {
          module: 'medico',
        },
      },
      {
        name: 'doctor.settings.categories.create',
        path: 'medical/form_categories/create',
        component: lazyLoading('Medico/FormCategories/Create'),
        meta: {
          module: 'medico',
        },
      },
      {
        name: 'doctor.settings.categories.edit',
        path: 'medical/form_categories/:id/edit',
        component: lazyLoading('Medico/FormCategories/Edit'),
        meta: {
          module: 'medico',
        },
      },
      {
        name: 'doctor.settings.items',
        path: 'medical/form_items',
        component: lazyLoading('Medico/FormItems/Index'),
        meta: {
          module: 'medico',
        },
      },
      {
        name: 'doctor.settings.items.create',
        path: 'medical/form_items/create',
        component: lazyLoading('Medico/FormItems/Create'),
        meta: {
          module: 'medico',
        },
      },
      {
        name: 'doctor.settings.items.edit',
        path: 'medical/form_items/:id/edit',
        component: lazyLoading('Medico/FormItems/Edit'),
        meta: {
          module: 'medico',
        },
      },
      {
        name: 'doctor.profile',
        path: 'profile',
        component: lazyLoading('Profile'),
        meta: {
          module: 'logins',
        },
      },
      {
        name: 'doctor.employees',
        path: 'employees',
        component: lazyLoading('Employees/Index'),
        meta: {
          module: 'logins',
        },
      },
      {
        name: 'doctor.employees.create',
        path: 'employees/create',
        component: lazyLoading('Employees/Create'),
        meta: {
          module: 'logins',
        },
      },
      {
        name: 'doctor.employees.edit',
        path: 'employees/:id/edit',
        component: lazyLoading('Employees/Edit'),
        meta: {
          module: 'logins',
        },
      },
      {
        name: 'doctor.payslips',
        path: 'employees/payslips',
        component: lazyLoading('Employees/Payslips/Index'),
        meta: {
          module: 'logins',
        },
      },
      {
        name: 'doctor.payslips.create',
        path: 'employees/payslips/create',
        component: lazyLoading('Employees/Payslips/Create'),
        meta: {
          module: 'logins',
        },
      },
      {
        name: 'doctor.payslips.edit',
        path: 'employees/payslips/:id/edit',
        component: lazyLoading('Employees/Payslips/Edit'),
        meta: {
          module: 'logins',
        },
      },
      {
        name: 'doctor.customers',
        path: 'customers',
        component: lazyLoading('Customers/Index'),
        meta: {
          module: 'logins',
        },
      },
      {
        name: 'doctor.customers.create',
        path: 'customers/create',
        component: lazyLoading('Customers/Create'),
        meta: {
          module: 'logins',
        },
      },
      {
        name: 'doctor.customers.edit',
        path: 'customers/:id/edit',
        component: lazyLoading('Customers/Edit'),
        meta: {
          module: 'logins',
        },
      },
      {
        name: 'doctor.users',
        path: 'users',
        component: lazyLoading('Users/Index'),
        meta: {
          module: 'logins',
        },
      },
      {
        name: 'doctor.not_linked_users',
        path: 'not_linked_users',
        component: lazyLoading('Users/NotLinkedIndex'),
        meta: {
          module: 'logins',
        },
      },
      {
        name: 'doctor.share_to_accounts',
        path: 'share_to_accounts',
        component: lazyLoading('Users/ShareToAccounts'),
        meta: {
          module: 'logins',
        },
      },
      {
        name: 'doctor.users.create',
        path: 'users/create',
        component: lazyLoading('Users/Create'),
        meta: {
          module: 'logins',
        },
      },
      {
        name: 'doctor.users.edit',
        path: 'users/:id/edit',
        component: lazyLoading('Users/Edit'),
        meta: {
          module: 'logins',
        },
      },
      {
        name: 'doctor.notificationCampaign.create',
        path: 'notificationCampaign/create',
        component: lazyLoading('NotificationCampaign/Create'),
        meta: {
          module: 'logins',
        },
      },
      {
        name: 'doctor.notificationCampaign.edit',
        path: 'notificationCampaign/:id/edit',
        component: lazyLoading('NotificationCampaign/Edit'),
        meta: {
          module: 'logins',
        },
      },
      {
        name: 'doctor.user_groups',
        path: 'user_groups',
        component: lazyLoading('UserGroups/Index'),
        meta: {
          module: 'logins',
        },
      },
      {
        name: 'doctor.user_groups.create',
        path: 'user_groups/create',
        component: lazyLoading('UserGroups/Create'),
        meta: {
          module: 'logins',
        },
      },
      {
        name: 'doctor.user_groups.edit',
        path: 'user_groups/:id/edit',
        component: lazyLoading('UserGroups/Edit'),
        meta: {
          module: 'logins',
        },
      },
      {
        name: 'doctor.roles',
        path: 'roles',
        component: lazyLoading('Roles/Index'),
        meta: {
          module: 'logins',
        },
      },
      {
        name: 'doctor.roles.create',
        path: 'roles/create',
        component: lazyLoading('Roles/Create'),
        meta: {
          module: 'logins',
        },
      },
      {
        name: 'doctor.roles.edit',
        path: 'roles/:id/edit',
        component: lazyLoading('Roles/Edit'),
        meta: {
          module: 'logins',
        },
      },
      {
        name: 'doctor.permissions',
        path: 'permissions',
        component: lazyLoading('Permissions/Index'),
        meta: {
          module: 'logins',
        },
      },
      {
        name: 'doctor.permissions.create',
        path: 'permissions/create',
        component: lazyLoading('Permissions/Create'),
        meta: {
          module: 'logins',
        },
      },
      {
        name: 'doctor.permissions.edit',
        path: 'permissions/:id/edit',
        component: lazyLoading('Permissions/Edit'),
        meta: {
          module: 'logins',
        },
      },
      {
        name: 'doctor.locations',
        path: 'locations',
        component: lazyLoading('Location/Index'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.locations.create',
        path: 'locations/create',
        component: lazyLoading('Location/Create'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.locations.edit',
        path: 'locations/:id/edit',
        component: lazyLoading('Location/Edit'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.breeds',
        path: 'breeds',
        component: lazyLoading('PetBreeds/Index'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.breeds.create',
        path: 'breeds/create',
        component: lazyLoading('PetBreeds/Create'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.breeds.edit',
        path: 'breeds/:id/edit',
        component: lazyLoading('PetBreeds/Edit'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.species',
        path: 'species',
        component: lazyLoading('PetSpecies/Index'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.species.create',
        path: 'species/create',
        component: lazyLoading('PetSpecies/Create'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.species.edit',
        path: 'species/:id/edit',
        component: lazyLoading('PetSpecies/Edit'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.countries',
        path: 'countries',
        component: lazyLoading('Country/Index'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.countries.create',
        path: 'countries/create',
        component: lazyLoading('Country/Create'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.countries.edit',
        path: 'countries/:id/edit',
        component: lazyLoading('Country/Edit'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.states',
        path: 'states',
        component: lazyLoading('State/Index'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.states.create',
        path: 'states/create',
        component: lazyLoading('State/Create'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.states.edit',
        path: 'states/:id/edit',
        component: lazyLoading('State/Edit'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.cities',
        path: 'cities',
        component: lazyLoading('City/Index'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.cities.create',
        path: 'cities/create',
        component: lazyLoading('City/Create'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.cities.edit',
        path: 'cities/:id/edit',
        component: lazyLoading('City/Edit'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.categories',
        path: 'categories',
        component: lazyLoading('Category/Index'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.categories.create',
        path: 'categories/create',
        component: lazyLoading('Category/Create'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.categories.edit',
        path: 'categories/:id/edit',
        component: lazyLoading('Category/Edit'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.tax_categories',
        path: 'tax_categories',
        component: lazyLoading('TaxCategory/Index'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.tax_categories.create',
        path: 'tax_categories/create',
        component: lazyLoading('TaxCategory/Create'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.tax_categories.edit',
        path: 'tax_categories/:id/edit',
        component: lazyLoading('TaxCategory/Edit'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.services',
        path: 'services',
        component: lazyLoading('Services/Index'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.services.create',
        path: 'services/create',
        component: lazyLoading('Services/Create'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.services.edit',
        path: 'services/:id/edit',
        component: lazyLoading('Services/Edit'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.measurements',
        path: 'measurements',
        component: lazyLoading('Measurements/Index'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.measurements.create',
        path: 'measurements/create',
        component: lazyLoading('Measurements/Create'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.measurements.edit',
        path: 'measurements/:id/edit',
        component: lazyLoading('Measurements/Edit'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.associatedLabs',
        path: 'associated-labs',
        component: lazyLoading('AssociatedLabs/Index'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.associatedLabs.create',
        path: 'associated-labs/create',
        component: lazyLoading('AssociatedLabs/Create'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.associatedLabs.edit',
        path: 'associated-labs/:id/edit',
        component: lazyLoading('AssociatedLabs/Edit'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.publicServiceDescriptions',
        path: 'service-descriptions',
        component: lazyLoading('PublicServiceDescription/Index'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.publicServiceDescriptions.create',
        path: 'service-descriptions/create',
        component: lazyLoading('PublicServiceDescription/Create'),
        meta: {
          module: 'menu',
        },
      },
      {
        name: 'doctor.publicServiceDescriptions.edit',
        path: 'service-descriptions/:id/edit',
        component: lazyLoading('PublicServiceDescription/Edit'),
        meta: {
          module: 'menu',
        },
      },
    ],
  },
]
